import React from 'react';
import { Button } from '@/components/ui/button';
import Image from 'next/image';

interface GoogleLoginButtonProps {
  onClick: () => Promise<void>;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onClick }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onClick();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleClick}
      className="w-full flex items-center justify-center gap-2"
      variant="outline"
      disabled={isLoading}
    >
      {isLoading ? (
        'Signing in...'
      ) : (
        <>
          <Image
            src="/google-icon.svg"
            alt="Google logo"
            width={20}
            height={20}
          />
          Continue with Google
        </>
      )}
    </Button>
  );
};

export default GoogleLoginButton;
